<div class="modal-header">
    <h5 class="text-center w-100">{{discountId ? 'Edit Discount' : 'Add Discount'}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal(false)">
    </button>
</div>

<form #discountForm="ngForm" (ngSubmit)="saveDiscount(discountForm)" novalidate>
    <div class="modal-body">
        <div class="text-center py-5" *ngIf="isLoading">
            <i class="fa fa-spin fa-spinner fa-pulse fa-3x"></i>
        </div>

        <div class="container" *ngIf="!isLoading">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label class="form-label">Discount Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" name="discount_name" #discount_name="ngModel"
                        [(ngModel)]="discountData.discount_name" placeholder="Enter Discount Name" required>
                    <div class="text-danger small" *ngIf="discount_name.touched && discount_name.invalid">
                        Discount name is required.
                    </div>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">Discount Type <span class="text-danger">*</span></label>
                    <select class="form-select" name="discount_type" #discount_type="ngModel"
                        [(ngModel)]="discountData.discount_type" (change)="onTypeChange()" required>
                        <option value="" disabled>Select Type</option>
                        <option value="percentage">Percentage</option>
                        <option value="flat">Flat</option>
                    </select>
                    <div class="text-danger small" *ngIf="discount_type.touched && discount_type.invalid">
                        Discount type is required.
                    </div>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        Discount {{discountData.discount_type == 'percentage' ? '(%)' : '(Amount)'}}
                        <span class="text-danger">*</span>
                    </label>
                    <input type="number" class="form-control" name="discount" #discount="ngModel"
                        [(ngModel)]="discountData.discount" placeholder="Enter Discount" min="0"
                        [max]="discountData.discount_type == 'percentage' ? 100 : null" required>
                    <div class="text-danger small" *ngIf="discount.touched && discount.invalid">
                        <span *ngIf="discount.errors?.required">Discount is required.</span>
                        <span *ngIf="discount.errors?.max">Percentage cannot exceed 100.</span>
                        <span *ngIf="discount.errors?.min">Discount cannot be negative.</span>
                    </div>
                </div>

                <div class="col-md-6 mb-3" *ngIf="discountData.discount_type == 'percentage'">
                    <label class="form-label">Cap Amount</label>
                    <input type="number" class="form-control" name="cap_amount" [(ngModel)]="discountData.cap_amount"
                        placeholder="Enter Cap Amount" min="0">
                    <small class="text-muted">Maximum discount amount. 0 means no cap.</small>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">Discount Source <span class="text-danger">*</span></label>
                    <ng-select name="discount_source" #discount_source="ngModel"
                        [(ngModel)]="discountData.discount_source" [items]="sourceOptions" [multiple]="true"
                        [closeOnSelect]="false" placeholder="Select Source" required>
                    </ng-select>
                    <div class="text-danger small" *ngIf="discount_source.touched && discount_source.invalid">
                        At least one source is required.
                    </div>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">Applicable Staff</label>
                    <ng-select name="applicable_staff" [(ngModel)]="discountData.applicable_staff" [items]="staffList"
                        bindValue="value" bindLabel="key" [multiple]="true" [closeOnSelect]="false"
                        [loading]="isStaffLoading" [searchable]="true"
                        [searchFn]="staffSearch" placeholder="Search and select staff">
                        <ng-template ng-option-tmp let-item="item">
                            {{item.key}} <small class="text-muted">({{item.value}})</small>
                        </ng-template>
                    </ng-select>
                    <small class="text-muted">Leave empty to apply for all staff.</small>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">Valid From</label>
                    <input type="date" class="form-control" name="valid_from"
                        [(ngModel)]="discountData.valid_from">
                    <!-- <small class="text-muted">Optional.</small> -->
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">Valid To</label>
                    <input type="date" class="form-control" name="valid_to" [(ngModel)]="discountData.valid_to">
                    <!-- <small class="text-muted">Optional.</small> -->
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label d-block">Active</label>
                    <div class="form-check form-switch form-switch-lg" dir="ltr">
                        <input type="checkbox" class="form-check-input" name="is_active"
                            [(ngModel)]="discountData.is_active">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal(false)">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || isLoading">
            <i class="fa fa-spin fa-spinner me-1" *ngIf="isSubmitting"></i>
            {{discountId ? 'Update' : 'Save'}}
        </button>
    </div>
</form>
